var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-rounded-md tw-inline tw-p-1 tw-text-white tw-text-sm",class:_setup.colors[_vm.alarm.status]},[_vm._v(" "+_vm._s(_vm.alarm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }